<template>
  <div class="header">
    <div class="pc_container">
      <a aria-current="page" href="/" class="router-link-active router-link-exact-active" title="ReelShortPro">
        <!-- <img src="../../static/img/logo_banner.BLtRJn-A.png" alt="ReelShortPro" class="logo" /> -->
        <img src="@/assets/logo_pc2.png" alt="ReelShortPro" class="logo" />
      </a>
      <div class="link_wrapper">
        <a href="/hot" class="router-link-active router-link-exact-active link_item -active" :class="{ active: $route.name == 'hot' }">{{ $t('_h._zrm') }}</a>
        <a href="/latest" class="link_item" :class="{ active: $route.name == 'latest' }">{{ $t('_h._zxd') }}</a>
        <a href="/ranking" class="link_item" :class="{ active: $route.name == 'ranking' }">{{ $t('_h._phb') }}</a>
        <a href="/wallpaper" class="link_item" :class="{ active: $route.name == 'wallpaper' }">{{ $t('_h._qz') }}</a>
      </div>
      <!-- 搜索框 -->
      <div class="search_bar_wrapper">
        <div class="search-bar-wrapper">
          <div class="search-input-container">
            <div style="position: absolute; left: 5px" v-if="searching">
              <LoadingOutlined />
            </div>
            <div class="dkrwt" @click="onClear" v-if="searchVal.length > 0">
              <CloseOutlined />
            </div>
            <input type="text" class="search-input" :class="{ searching: searching }" :placeholder="$t('_h._ssww')" v-model="searchVal" @input="onSearchInput" />
            <div class="search-icons-wrapper">
              <!---->
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAMAAABU4iNhAAAAPFBMVEUAAACmpqanp6empqalpaWnp6enp6elpaWmpqavr6+mpqanp6enp6empqanp6empqafn5+mpqaqqqqlpaUpGmwDAAAAFHRSTlMA/yDf77+fgGAQkECvz39wEFAwMLOIfJgAAAEESURBVHic7ZTNdsQgCIW94l/UJE37/u9akkmmJ4Cz6GoWw/KeT7kg6NwnrmhLJABzL9NrLuIZIfkhN/UDWEspdT9CZQB6TkvbldQnZpchWKVgoRPrItsXu1k1WS11RlBleZH6VAOi1BLIakoGmrBkXsl6kPoG2H2uIJmFTNAV4P6sXTt/BFf6fRMi0pBs/yQTuk3+yOwrgk2qiprq8DPZfBe4w3lgU05DRrDWYdEvwpcaNfGVuifZGFueZWtuokL3od8MS7t+W8cSYJfp/Mwbt1zssdB64v+88qeQcq49PJZ+Hv0Px+qeQXn3M0Sd50+BiHpup/XBNKpzQT77GI3Gwr93/ALbNQWQzEx8ZgAAAABJRU5ErkJggg==" class="search-icon" />
            </div>
          </div>
          <div class="search-popup" v-if="searchVideo.length > 0">
            <div class="hot-searches">
              <!-- <div class="hot-searches-header">
                <div class="hot-icon-wrapper">
                  <div class="hot-icon oss-image-wrapper hot-icon xx1" style=""></div>
                </div>
                <span class="hot-searches-title">Hot Searches</span>
              </div> -->
              <div class="hot-searches-list">
                <!--[-->
                <div class="hot-search-item" v-for="(item, i) in searchVideo" :key="i" @click="onVideoSearch(item)">{{ item.title }}</div>
                <!--]-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="right">
        <!-- <li class="download usermenu">
          Download
          <div class="menubox">
            <div class="download-app popover">
              <div class="placeholder"></div>
              <div class="download-app-content">
                <div class="download-app-left">
                  <span class="download-app-text">Download on iOS or Android</span>
                  <div class="download-app-gesture-wrap">
                    <div class="download-app-gesture oss-image-wrapper download-app-gesture" style="background: url('https://file-cdn..cc/image/41/c29a75d73bc5f9874d4a8be0c5fd4e.png?image_process=resize,quality,Q_75/format,webp') center top / 100% no-repeat"></div>
                    <div class="download-app-gesture-text-wrap"><span class="download-app-gesture-text">Scan QR code to download ReelShortPro App</span></div>
                  </div>
                </div>
                <div class="download-app-right">
                  <div class="download-app-qrcode oss-image-wrapper download-app-qrcode" style="background: url('https://file-cdn..cc/image/1d/95e19bc8d8426ecbbd6dab6bdf6550.png?image_process=resize,w_124,h_124/quality,Q_75/format,webp') center top / 100% no-repeat"></div>
                </div>
              </div>
            </div>
          </div>
        </li> -->
        <!-- 历史记录 -->
        <!-- <li class="record usermenu">
          {{ $t('_h._lsjl') }}
          <div class="wrap-a popover popover-enter-to menubox">
            <ul class="tab">
              <li class="active">{{ $t('_h._lsjl') }}</li>
            </ul>
            <ul class="list drama_list column">
              <li class="item" itemscope="" v-for="(item, i) in historyList" :key="i" @click="onVideo(item)">
                <img :src="item.img" :alt="item.title" class="img" />
                <div class="right">
                  <div class="title">{{ item.title }}</div>
                  <div class="tag text-ellipsis">{{ item.content }}</div>
                </div>
              </li>
            </ul>
            <button class="more" @click="onMoreHistofy()">{{ $t('_h._gd') }}</button>
          </div>
        </li> -->

        <!-- 下载app -->
        <Download></Download>

        <!-- 客服 -->
        <Service v-if="isLogin" :chat_unread="userInfo.chat_unread"></Service>

        <!-- 多语言 -->
        <Language></Language>

        <li class="user usermenu">
          <img src="../../static/img/icon_avatar.C-e_HuIE.png" class="avatar" v-if="!isLogin" />
          <img :src="userInfo.avatar && userInfo.avatar + '?r_avatar=' + parseInt(Math.random() * 1000)" class="avatar" v-else />
          <!-- 未登录时 -->
          <div class="userinfo popover user_header menubox" v-if="!isLogin">
            <div class="info">
              <img src="../../static/img/icon_avatar.C-e_HuIE.png" class="avatar" />
              <div class="middle">
                <p class="name">Welcome</p>
                <p class="uid -google">ID:******</p>
              </div>
              <button class="signin" @click="onLoginShow">{{ $t('_h._dl') }}</button>
            </div>
            <div class="topup">
              <div class="coins">
                <span class="number">0</span>
                <div class="coins-logo">
                  <div class="logo oss-image-wrapper logo xx2" style=""></div>
                  <span class="text">{{ $t('_h._ye') }}</span>
                </div>
              </div>
              <div class="bonus">
                <span class="number">0</span>
                <div class="bonus-logo">
                  <div class="logo oss-image-wrapper logo xx3" style=""></div>
                  <span class="text">{{ $t('_h._dj') }}</span>
                </div>
              </div>
              <!-- <button class="topup_btn column">TOP UP</button> -->
            </div>
            <!-- <button class="topup_btn row">TOP UP</button> -->
            <div class="line"></div>
          </div>

          <!-- 登录时 -->
          <div class="userinfo popover user_header menubox" v-if="isLogin">
            <div class="info">
              <img :src="userInfo.avatar && userInfo.avatar + '?r_avatar=' + parseInt(Math.random() * 1000)" class="avatar" />
              <div class="middle">
                <p class="name">{{ userInfo.email }}</p>
                <p class="uid -google">ID:{{ userInfo.uid }}</p>
              </div>
              <button class="signin" @click="onSignOut">Sign Out</button>
            </div>
            <!---->
            <div class="wallet-header sserrq">
              <a class="wlft" href="/dashboard">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._ybp') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/wallet">
                <div class="wallet-header-left wallet-lft">
                  <!-- <div
                    class="wallet-icon wallet-icon-normal oss-image-wrapper wallet-icon wallet-icon-normal item-icon">
                  </div> -->
                  <span class="wallet-text wallet-text-small">{{ $t('_h._wdqb') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/record">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._scjl') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/message">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._xxzx') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <!-- <a class="wlft" href="/share">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._fxhy') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a> -->
              <a class="wlft" href="/help">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._bzzx') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/adv">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._ggtf') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/invest" v-if="userInfo.is_apply == 2">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._bqtz') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/apply" v-else>
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._bqtz') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/qualifications">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_cd._gszz') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
              <a class="wlft" href="/setting">
                <div class="wallet-header-left wallet-lft">
                  <span class="wallet-text wallet-text-small">{{ $t('_h._sz') }}</span>
                  <div class="right-icon oss-image-wrapper right-icon item-img"></div>
                </div>
              </a>
            </div>
            <div class="topup">
              <!-- <div class="coins">
                <span class="number">${{ wallet.balance }}</span>
                <div class="coins-logo">
                  <div class="logo oss-image-wrapper logo xx2"></div>
                  <span class="text">{{ $t('_h._ye') }}</span>
                </div>
              </div> -->
              <!-- <div class="bonus">
                <span class="number">${{ wallet.freeze }}</span>
                <div class="bonus-logo">
                  <div class="logo oss-image-wrapper logo xx3"></div>
                  <span class="text">{{ $t('_h._dj') }}</span>
                </div>
              </div> -->
              <!-- <button class="topup_btn column">TOP UP</button> -->
            </div>
            <!-- <button class="topup_btn row">TOP UP</button> -->
            <div class="line"></div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 登录弹框 -->
    <!-- <login ref="loginBox"></login> -->
  </div>
</template>

<script>
import Language from './language.vue'
import Service from './service.vue'
import Download from './download.vue'
// import Login from './Login.vue'
import { LoadingOutlined, CloseOutlined } from '@ant-design/icons-vue'
export default {
  components: { Language, Service, LoadingOutlined, CloseOutlined, Download },
  name: 'HeadVue',
  data() {
    return {
      isLogin: false,
      userInfo: {},
      wallet: {},
      showLogin: false,
      historyList: [],

      searching: false,
      searchVideo: [],
      searchVal: ''
    }
  },
  watch: {
    isUpdate(newVal, oldVal) {
      console.log('状态变化', newVal, oldVal)
      if (newVal === true) {
        // 状态变为 true 时执行
        let that = this
        this.$api.user.getUserInfo().then((res) => {
          that.userInfo = res.data
          localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data))
        })
        // 执行完后可以选择重置状态
        this.$store.commit('update/setUpdate', false)
      }
    }
  },
  created() {
    this.initshow()
    this.initState()
  },
  computed: {
    isUpdate() {
      return this.$store.state.update.isUpdate
    }
  },
  methods: {
    onClear() {
      this.searchVal = ''
      this.searchVideo = []
      this.searching = false
    },
    /**
     * 搜索
     */
    onSearchInput() {
      //通知上级
      console.log(this.searchVal)

      if (this.searchVal.length < 2) {
        this.searchVideo = []
        return
      }

      // 搜索符合的店铺名称
      this.searching = true

      let that = this
      this.$api.video.searchVideoList({ keyword: this.searchVal }).then((res) => {
        that.searching = false
        that.searchVideo = res.data
      })
    },
    onVideoSearch(item) {
      window.location.href = '/video?code=' + item.code
    },
    onVideo(item) {
      this.$router.push({ name: 'video', query: { code: item.code } })
    },

    onMoreHistofy() {
      this.$router.push({ name: 'record', query: { i: 2 } })
    },
    onLoginShow() {
      this.$router.push({ name: 'login' })
      // this.$refs.loginBox.show()
    },
    /**
     * 退出登录
     */
    onSignOut() {
      localStorage.removeItem(this.$Const.KEY_TOKEN)
      localStorage.removeItem(this.$Const.KEY_INFO)
      this.isLogin = false
      this.userInfo = {}
      this.$router.push({ name: 'index' })
    },
    initshow() {
      let t = this.$route.query?.t
      if (t == 'login') {
        this.onLoginShow()
      }
    },
    initState() {
      //获取登录状态
      this.isLogin = this.$common.isLogin()

      let that = this
      if (this.isLogin) {
        this.$api.user.getUserInfo().then((res) => {
          that.userInfo = res.data
          localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data))
        })

        this.getUserHistoryList()
        //this.getWallet()
      }
    },
    getUserHistoryList() {
      let that = this
      this.$api.user.getUserHistoryList({ page: 1, size: 10 }).then((res) => {
        that.historyList = res.data
      })
    },
    getWallet() {
      // var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        // hide()
        if (res.data.length <= 0) {
          that.$message.error('error')
          return
        }
        that.wallet = res.data
      })
    }
  }
}
</script>

<style>
.usermenu:hover .menubox {
  opacity: 1;
  visibility: visible;
}

.menubox {
  opacity: 0;
  visibility: hidden;
}

.sserrq {
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.item-icon {
  background: url('@/static/img/icon-wallet.png') center top / 100% no-repeat;
}

.item-img {
  background: url('@/static/img/icon_right.png') center top / 100% no-repeat;
}

.wlft {
  width: 100%;
}

.wallet-lft {
  height: 25px;
  width: 100%;
  justify-content: space-between !important;
}
.xx1 {
  background: url('../../static/img/hot.png') center top / 100% no-repeat;
}
.xx2 {
  background: url('../../static/img/coins.png') center top / 100% no-repeat;
}
.xx3 {
  background: url('../../static/img/bonus.png') center top / 100% no-repeat;
}

.dkrwt {
  cursor: pointer;
  position: absolute;
  right: 40px;
}

.dkrwt:hover {
  color: #888;
}
</style>
